import { Dialog, DialogContent, Stack } from "@altimateai/lego";
import contract_icon from "../../assets/icons/contract_icon.svg";
import classnames from "classnames";
import styles from "./styles.module.scss";
import { CueCodeEditor } from "../../components/codeEditor";
import { CopyButton } from "../../components/copyButton";

interface CodeProps {
  isOpen: boolean;
  toggle: () => void;
  contract: {
    status?: string;
    name?: string;
    code?: string;
  };
}

const Code = ({ isOpen, toggle, contract }: CodeProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={open => !open && toggle()}>
      <DialogContent className="max-w-6xl">
        <Stack justify="between" align="start" className="mb-4">
          <Stack align="center">
            <div
              className={classnames("me-2", styles.icon_bg, {
                [styles.active]: contract.status === "active",
                [styles.inactive]: contract.status === "inactive",
              })}
            >
              <img src={contract_icon} alt="" />
            </div>
            <div className="me-4 fs-3 fw-semibold">{contract.name}</div>
            <CopyButton
              size="sm"
              value={contract.code ?? ""}
              label="Copy Code"
              copiedLabel="Code Copied"
            />
          </Stack>
        </Stack>
        <CueCodeEditor value={contract.code} />
      </DialogContent>
    </Dialog>
  );
};

export { Code };
